module.exports = __webpack_public_path__ + "img/1121876618.b4dccdd9.png";